import * as yup from "yup";
import BaseForm from "../../../../../../../../shared/components/form/BaseForm";
import FormSelect from "../../../../../../../../shared/components/select/FormSelect";
import FormTextarea from "../../../../../../../../shared/components/textarea/FormTextarea";

const CreateDataApiPermissionForm = ({ onSubmitHandler, roles, datasets }) => {
  const validationSchema = yup.object({
    role: yup.string().required("El rol es obligatorio"),
    dataset: yup.string().required("El nombre del dataset es obligatorio"),
  });

  const defaultValues = {
    role: "",
    dataset: "",
    datasetFilter: null,
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
    >
      <div className="flex flex-col justify-between gap-y-4">
        <FormSelect name="role" label="Rol" options={roles} required />
        <FormSelect
          name="dataset"
          label="Dataset"
          options={datasets}
          required
        />
        <FormTextarea name="datasetFilter" label="Filtro del dataset" />
      </div>
    </BaseForm>
  );
};

export default CreateDataApiPermissionForm;
